import { ScreenSize } from '../../api/ScreenSize';
import { MainMenu } from './components/MainMenu';
import { Lightning, Log, Registry, Router, Utils } from '@lightningjs/sdk';
import { fullUrlWithRecipe, Recipes } from '../../Business/utility/ImageRecipeUtil';
import { CmsPage } from '../content/CmsPage';
import { PageType } from '../../api/models/Shared.types';
import { ErrorTranslationKeys } from '../../api/models/TranslationKeys';
import { SearchPage } from '../content/searchpage/SearchPage';

export class MainPage extends Lightning.Component {
  static _template() {
    return {
      Background: {
        x: 0,
        y: 0,
        ...ScreenSize,
        src: Utils.asset('images/background.png'),
      },
      ...ScreenSize,
      Content: {
        type: Lightning.Component,
        x: 0,
        y: 0,
        h: h => h,
        w: w => w,
      },
      Menu: {
        zIndex: 100,
        x: 0,
        y: 0,
        w: 1027,
        h: ScreenSize.h,
        type: MainMenu,
        visible: false,
      },
    };
  }

  _onDataProvided() {
    const menu = this.tag('Menu');
    if (!menu.visible) {
      super._init();
      this.reset();
      menu.visible = true;
    } else if (this.params.reset) {
      this.reset();
    }
    // if data for autoplay passed -> open autoplay screen
    if (this.params.autoplayDialog) {
      Log.info('[MainPage] params autoplayDialog: ', this.params.autoplayDialog);
      // this.fireAncestors('$openDialog', this.params.autoplayDialog);
      this.$openModal(this.params.autoplayDialog.page, this.params.autoplayDialog.params);
      // Router.focusWidget('Dialog');
    }
  }

  _firstActive() {
    if (!this.params.backend.serverTimeCheckPassed && !this.deviceTimeErrorTriggered) {
      Log.warn('Time Different from server');
      this.deviceTimeErrorTriggered = true;
      this.fireAncestors(
        '$showMessage',
        this.params.backend.translations.forKey(ErrorTranslationKeys.error_device_time)
      );
    }
  }

  reset() {
    const menu = this.tag('Menu');
    this.focusSide = true;
    menu.initialize(this.params.backend).then(() => {
      Registry.setTimeout(() => {
        menu.openDefaultPage();
      }, 0);
    });
  }

  _getFocused() {
    return this.focusSide ? this.tag('Menu') : this.tag('Content').children[this.tag('Content').children.length - 1];
  }

  _handleRight() {
    this.focusSide = false;
  }

  _handleLeft() {
    this.focusSide = true;
  }

  _handleBack() {
    if (this.params.backend.playerController.isInErrorState) {
      this.fireAncestors('$verifyCloseApp');
    } else {
      Router.navigate('play');
    }
  }

  $openPage(page, params, addOntoStack = false) {
    if (params != null) {
      Log.info(`[MainPage] Opening page ${page.name} with parameters`, params);
    } else {
      Log.info(`[MainPage] Opening page ${page.name}`);
    }

    const content = this.tag('Content');
    if (content) {
      if (content.childList.length > 0) {
        // check if the new page is the same as the old one and prevent a refresh
        if (params?.menuItem && content.childList.last.params?.menuItem === params?.menuItem) {
          return;
        }
      }
      this.tag('Background').src = Utils.asset('images/background.png');
      this.focusStack = [];
      if (addOntoStack) {
        // dont clear childList
        // make the rest invisible
        content.childList.forEach(el => (el.visible = false));
      } else {
        this.clearChildList(content);
      }
      content.childList.a({
        w: w => w,
        h: h => h,
        type: page,
        params: params,
      });
      // this.focusStack.push(content.childList.last);
      // this._refocus();
    }
  }

  $popFromStack() {
    const content = this.tag('Content');
    content.childList.remove(content.childList.last);
    content.childList.last.visible = true;
    this._refocus();
  }

  clearChildList(element) {
    element.childList.forEach(child => {
      this.focusStack = this.focusStack.filter(el => el !== child);
    });
    element.childList.clear();
  }

  $focusMenu() {
    this.focusSide = true;
  }

  $focusContent() {
    this.focusSide = false;
  }

  $updateBackgroundImage(image) {
    const url = fullUrlWithRecipe(this.params.backend, image, Recipes.Page.Background);
    this.tag('Background').src = url ? url : Utils.asset('images/background.png');
    this.tag('Background').on('txError', () => {
      this.tag('Background').src = Utils.asset('images/background.png');
    });
  }

  $updateMenu(pageType) {
    this.tag('Menu').updateMenuForPage(pageType);
  }

  $CMSActionOpenPage(action, backend) {
    // console.log('[MainPage] $CMSActionOpenPage', action, caller);
    // find if action id exists in current active menu and select
    if (this.tag('Menu').selectPageIdInCurrentMenu(action.id)) return true;
    // if not search entire menu on id and take first occurance and select
    if (this.tag('Menu').searchFullMenuAndSelect(action.id)) return true;
    // nothing found: open page in fullscreen
    //TODO: add other extra pagetypes
    switch (action.extra.pageType) {
      case PageType.Cms:
        this.widgets.modal.$openModal(CmsPage, {
          backend: backend,
          assetType: action.type,
          assetId: action.id,
          fullScreen: true,
        });
        break;
      case PageType.Search:
        this.widgets.modal.$openModal(SearchPage, {
          backend: backend,
          fullScreen: true,
          menuItem: {
            pageId: action.id,
            title: 'SearchPage Fullscreen',
          },
        });
        break;
    }
  }

  $openModal(page, params) {
    this.widgets.modal.$openModal(page, params);
  }
}
